
export { default } from './connected-draggable';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/draggable/index.js
// module id = 1897
// module chunks = 1